module.exports = __webpack_public_path__ + "static/down_bg-83776addb7a1660e0d72adaa4adb9357.png";